import config from './config'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import lib from './lib'

window.vinstance = new Vue({
  render: h => h(App)
}).$mount('#app')

const configOverride = `./config/config.${document.location.hostname.split('.')[0]}.js?${Math.floor(new Date())}`

import(
       /* webpackIgnore: true */
       configOverride
      ).then((configModule) => {
        for (let i in configModule.default) {
          config[i] = configModule.default[i]
          console.log(`${configOverride} override: ${i}`)
        }
        window.data.config = config
        lib.updateStyle(config.css)
        lib.getData(config)
      }).catch((error) => {
        console.error(`${configOverride} could not be loaded: ${error}`)
        lib.updateStyle(config.css)
        lib.getData(config)
      })

window.setInterval(function () {
  lib.getData(config)
}, config.reloadInterval)

lib.checkVersion()
window.setInterval(function () {
  lib.checkVersion()
}, config.checkVersionInterval)

window.setInterval(function () {
  Vue.set(window.data, 'timebox', window.data.timebox + 1)
}, 1000)

/*
 *

-- build:
wa | split | terminal yarn lint --fix && yarn build | edit

-- test with kna config after build:
wa | split | terminal cp ~/projekte/newsscreen-hosting/config/config.screen-kna-dev.js dist/js/config/config.127.js && cd dist && livereload .

-- test with missing config after build:
wa | split | terminal rm dist/js/config/config.127.js && cd dist && livereload .

-- test with empty config after build:
wa | split | terminal echo "export default { }" > dist/js/config/config.127.js; cd dist && livereload .

 *
 *
 */
